import {  
  getFirestore,
  doc,
  getDoc
} from "firebase/firestore";
import formatData from "../utils/formatData";
import moment from "moment";
const getProgramMemberInfo = async function(id, uid) {
  let db = getFirestore();
  //get onsite data
  let startDate = '';//formatData('datepicker', new Date());
  let endDate = '';//formatData('datepicker', moment().add(6,'M'));
  let endProgramDate = '';
  let cancelProgramDate = '';
  // let endDateMin = '';//endDate;
  // let startDateText = formatData('date', new Date());
  // let endDateText = formatData('date', moment().add(6,'M'));


  let programRef = doc(db, "wellness_program", id );
  const docSnapProgram = await getDoc(programRef);
  
  const ref = doc(db, "wellness_program", id, "members", uid );
  let memberInfo = (await getDoc(ref));

  if( memberInfo.data().startDate != undefined ){
    startDate = formatData('datepicker', memberInfo.data().startDate.toDate());
    endDate = formatData('datepicker', moment(memberInfo.data().startDate.toDate()).add(1,'M'));
    // startDateText = formatData('date', memberInfo.data().startDate.toDate());
  }
  if( memberInfo.data().endDate != undefined ){
    endDate = formatData('datepicker', memberInfo.data().endDate.toDate());
    // endDateText = formatData('date', memberInfo.data().endDate.toDate());
  }

  if( memberInfo.data().endProgramDate != undefined ){
    endProgramDate = formatData('datepicker', memberInfo.data().endProgramDate.toDate());
  }

  if( memberInfo.data().cancelDate != undefined ){
    cancelProgramDate = formatData('datepicker', memberInfo.data().cancelDate.toDate());
  }

  let enableEndProgram = false;
  if( memberInfo.data().startDate != undefined ){
    const isAfterStartDateAdd1M = moment().isAfter(moment(memberInfo.data().startDate.toDate()).add(1, 'M'));
    const isAfterEndDate = moment().isAfter(moment(memberInfo.data().endDate.toDate()));
    if (isAfterStartDateAdd1M && isAfterEndDate && memberInfo.data().onsiteCount == memberInfo.data().memberOnsite ) {
        enableEndProgram = true;
    }
  }
  return {
    name: docSnapProgram.data().name,
    startDatePicker: startDate,
    endDatePicker: endDate,
    cancelDatePicker: cancelProgramDate,
    endProgramDatePicker: endProgramDate,
    // endDateMin: endDateMin,
    // startDateText: startDateText,
    // endDateText: endDateText,
    memberOnsite: memberInfo.data().memberOnsite || 2,
    memberTarget: memberInfo.data().memberTarget || '',
    memberPlan: memberInfo.data().memberPlan || '',
    programResult: memberInfo.data().programResultOther != undefined && memberInfo.data().programResultOther != '' ? memberInfo.data().programResultOther : memberInfo.data().programResult,
    programSummary: memberInfo.data().programSummary != undefined ? memberInfo.data().programSummary : "",
    isCancelProgram: memberInfo.data().isCancelProgram != undefined ? memberInfo.data().isCancelProgram : "",
    isPostTestCompleted: memberInfo.data().postVegetableTest != undefined ? true : false,
    enableEndProgram: enableEndProgram,
    // enableEndProgram: true,
    // isPostTestCompleted: true
    // cancelDate: memberInfo.data().cancelDate != undefined ? formatData('datepicker', memberInfo.data().cancelDate.toDate()) : "",
  }

};

export default getProgramMemberInfo;
